import {
	zencare_plus,
	zencare_standard,
	zencare_classic,
	flexicare,
	flexicare_mini,
	mini_comprehensive,
	comprehensive_auto,
	thirdparty_comprehensive,
	travel,
	gadget,
	laptopCover,
	primecare,
	primecare_plus,
	aiico_travel_cover
} from '@/contents/benefits'

type AddTPLANS = {
	title: string
	description: string
	options: {
		manual?: {
			title: string
			description: string
		}
		batch?: {
			title: string
			description: string
		}
	}
}
export type BenefitStoreContext = {
	[id: string]: Partial<{
		short_description?: string
		description?: string
		short_benefits: ShortBenefitsContext
		allBenefits?: {
			dialog: {
				benefits?: Array<
					| {
							tag?: string
							name?:
								| {
										q?: string
										a?: string
								  }
								| string
							benefit_details?: Array<{ q?: string; a?: string } | string>
					  }
					| string
				>
				what_is_covered?: string[]
				need_to_know?: string[]
				[id: string]: unknown
			}
			briefInfo?: string
		}
		gadget_types?: {
			label: string
			value: string
			rate: number
		}[]
		gadget_brands?: {
			label: string
			value: string
			gadget_type: string
		}[]
		gadget_model?: {
			label: string
			gadget_brand: string
			value: string
			gadget_type: string
		}[]
		card_label: string
		product_title?: string
		// This is required For everywhere we have dialog prompting for user to add staff to plan
		dialogLabels: {
			addToPlan?: AddTPLANS
			removeFromPlan?: AddTPLANS
		}
	}>
}

export const useProductBenefit = defineStore('productBenefit', {
	state: (): BenefitStoreContext => {
		return {
			[ProductCodeNames.FLEXICARE_HYGEIA]: flexicare.hygeia,
			[ProductCodeNames.FLEXICARE_BASTION]: flexicare.bastion,
			[ProductCodeNames.FLEXICARE_MINI_HYGEIA]: flexicare_mini.hygeia,
			[ProductCodeNames.FLEXICARE_MINI_BASTION]: flexicare_mini.bastion,
			[ProductCodeNames.ZENCARE_PLUS_BASTION]: zencare_plus,
			[ProductCodeNames.ZENCARE_PRIME_BASTION]: zencare_classic,
			[ProductCodeNames.ZENCARE_BASTION]: zencare_standard,
			[ProductCodeNames.PRIMECARE_BASTION]: primecare,
			[ProductCodeNames.PRIMECARE_PLUS_BASTION]: primecare_plus,
			[ProductCodeNames.MINI_COMPREHENSIVE]: mini_comprehensive,
			[ProductCodeNames.COMPREHENSIVE_AUTO]: comprehensive_auto,
			[ProductCodeNames.THIRD_PARTY]: thirdparty_comprehensive,
			[ProductCodeNames.TRAVEL_ALLIANZ]: travel,
			[ProductCodeNames.TRAVEL_AIICO]: aiico_travel_cover,
			[ProductCodeNames.GADGET]: gadget,
			[ProductCodeNames.LAPTOP_COVER]: laptopCover
		}
	},
	getters: {
		Benefits(state) {
			return state
		}
	},
	actions: {}
})
